import React, { useEffect, useState } from 'react';
import {
  Box,
  Divider,
  TextField,
  Paper,
  Typography,
  IconButton,
  InputAdornment,
  useTheme,
  Button,
  
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { forgotPasswordSchema } from '../../../helpers/validations/forgotPasswordValidation';
import { controlPanelAdminForgotPassword, studentForgotPassword } from '../../../api/login/loginService';
import { ROUTES } from '../../../constants/routes';
import { useSelector } from 'react-redux';

const ForgotPassword = ({ setStep, setFormData }) => {
  const currentLocation = useLocation();
  const routeName = currentLocation.pathname;
  const [showPassword, setShowPassword] = useState(false);
  const forgotToLoginMap = {
    [ROUTES.ADMINFORGOTPASSWORD]: ROUTES.ADMINSIGNIN,
  };

  const backToLoginPath = forgotToLoginMap[routeName] || ROUTES.STUDENTSIGNIN;

  // const { setStep, step } = props;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });
  const handleTogglePassword = () => setShowPassword(!showPassword);
  const customColors = useSelector(state => state.theme.customColors);
  const onSubmit = async data => {
    try {
      const formData = {
        emailId: data.email,
      };
      let result;
      switch (routeName) {
        case '/admin-forgot-password':
          result = await controlPanelAdminForgotPassword(formData);
          break;
        default:
          result = await studentForgotPassword(formData);
          break;
      }
      debugger
      if(result && result?.error === true){
        //showSnackbar(`User not found with this ${data.email}`, 'info');
        return 
      }
      setStep(2);
       setFormData({
        email: data.email,
        newPassword: data.password,
      });
      // toast.success(`OTP sent to ${data.email}`);
      //showSnackbar("OTP sent to registered email id", 'success');
    } catch (err) {
      //  toast.error(err.message  || 'Something went wrong. Please try again.');
      //showSnackbar(err.message || 'Something went wrong. Please try again.', 'error');
    }
  };

  const onFormError = formErrors => {
    const firstError = Object.values(formErrors)[0];
    if (firstError?.message) {
      // toast.error(firstError.message);
      //showSnackbar(firstError.message, 'error');
    }
  };

  return (
    
     <Box
          sx={{
            
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
          
          }}
        >
          <Box
            elevation={0}
            sx={{
              display: 'flex',
              maxWidth: 900,
             paddingLeft:{xs:"16px"},
               paddingRight:{xs:"16px"},
              flexDirection: { xs: 'column', md: 'row',sm:'row' },
              
              width: '100%',
              position:"relative",
              borderRadius: 0,
              overflow: 'hidden',
             
            }}
          >
            {/* Left Side - Brand Section */}
            <Box
              sx={{
                flex: 1,
                 background: 'linear-gradient(to right, #A73FF2 , #9300FD)',
                display: { xs: 'flex', md: 'flex' },
                 borderTopLeftRadius:"8px",
             borderBottomLeftRadius:{md:"8px",lg:"8px"},
       
            //  borderTopRightRadius:{xs:"8px"},  
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#f9f1fe',
               
                position: 'relative',
              }}
            >
              <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', width: '100%' }}>
              
                  <Box
                          component="img"
                          src="assets/White_Logo.png"
                          alt="Logo"
                          sx={{
                            // width: 160,
                            width:"70%",
                            height: 'auto',
                            zIndex: 10,
                                mb: "50px",
                               pt:{xs:1}
                          }}
                        />
                <Typography
                  variant="body1"
                  sx={{
                    mb: 6,
                    lineHeight: 1.7,
                    px: 3,
                    fontSize: '1rem',
                  }}
                >
                  Control School lets you focus on managing school operations while we take care of a clean and intuitive interface.
                </Typography>
                <Box sx={{ mt: 8, mb: 6 }}>
                  
                  
                </Box>
                {/* <Box sx={{ mt: 'auto', pt: 6 }}>
                  <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                    Read our{' '}
                    <Link 
                      href="#" 
                      sx={{ 
                        color: '#fff', 
                        textDecoration: 'underline',
                        '&:hover': { opacity: 0.9 }
                      }}
                    >
                      terms
                    </Link>
                    {' '}and{' '}
                    <Link 
                      href="#" 
                      sx={{ 
                        color: '#fff', 
                        textDecoration: 'underline',
                        '&:hover': { opacity: 0.9 }
                      }}
                    >
                      conditions
                    </Link>
                  </Typography>
                </Box> */}
              </Box>
            </Box>
    
            {/* Right Side - Login Form */}
            <Box
              sx={{
                   borderTopRightRadius:"8px",
                 borderBottomRightRadius:"8px",
                flex: 1,
                p: { xs: 4, sm: 6 },
                display: { xs: 'flex', md: 'flex' },
                flexDirection: 'column',
             
                justifyContent: 'center',
                backgroundColor: '#fff',
                
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 400,
                  mb: 4,
                  color: '#333',
                  fontSize: '2rem',
                }}
              >
                Forgot Password
              </Typography>    
           <form onSubmit={handleSubmit(onSubmit, onFormError)} noValidate>
         <TextField
          fullWidth
          size='small'
          label="UserName"
          variant="filled"
          sx={{ mb: 2 }}
          error={!!errors.email}
          {...register('email')}
          className="cp-form-control input-focus"
        />
        <TextField
          fullWidth
          size='small'
          label="password"
          name="password"
          variant="filled"
          className="cp-form-control input-focus"
          error={!!errors.password}
          {...register('password')}
        />
        <Button variant="contained" type='submit' fullWidth sx={{ mt: 2 , background:"#9300FD"}}
        >Submit</Button>
        <Box textAlign="right" mt={1} >
          <Link style={{color: '#9300FD',}} to={ROUTES.ADMINSIGNIN}>Login?</Link>
        </Box>
      </form>
    
            </Box>
          </Box>
        </Box>
  );
};

export default ForgotPassword;
